import axios, { AxiosInstance } from 'axios';
import { IApiResponse } from './interface';

const instance = axios.create();

class ApiClient {
    private client: AxiosInstance;

    constructor(factory: AxiosInstance) {
        this.client = factory;
    }

    get<T>(url: string, params: any = {}) {
        return this.client.get<IApiResponse<T>>(url, { params }).then(response => {
            const d = response.data;
            if (!d.ok) throw new Error(d.message || 'Неверный ответ API');
            return d.data;
        });
    }

    post<T>(url: string, data: any) {
        return this.client.post<IApiResponse<T>>(url, data).then(response => {
            const d = response.data;
            if (!d.ok) throw new Error(d.message || 'Неверный ответ API');
            return d.data;
        });
    }
}

export default new ApiClient(instance);
